module.exports = __webpack_public_path__ + "static/img/home_tanques.0aa545d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_tanques.png
// module id = 88
// module chunks = 0